import React, { useState } from 'react';
import DangerIcon from '@assets/icons/danger-alert-icon.svg';
import redAlertIcon from '@assets/icons/redAlert-icon.svg';
import 'FielderUtils/style.css';
import { cancelTaskRequest } from '@core/api/task/task.service';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser } from '@core/store/modules/session/sessionSelectors';
import { useLanguage } from 'FielderUtils/Contexts/LanguageContext';
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  IconButton,
  InputAdornment,
  Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid2';

const CancelTask = (props) => {
  const lan = useLanguage();
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [taskInfo, setTaskInfo] = useState({ description: '' });
  const [taskInfoRequest] = useState(props.taskInfoRequest || []);
  const [descError, setDescError] = useState(false);
  const handleClose = () => props.closeErrorMessage?.();
  const setFieldValue = (value, field) => {
    if (field === 'description') {
      setTaskInfo((prev) => ({ ...prev, description: value }));
      if (value && descError) setDescError(false);
    }
  };
  const handleCancelTask = () => {
    if (!taskInfo.description.trim()) {
      setDescError(true);
      return;
    }
    const timeStampMiliseconds = Date.now();

    for (let i = 0; i < taskInfoRequest.length; i++) {
      const t = taskInfoRequest[i];
      const body = {
        type: t.typeOfRequest,
        cancel: {
          comment: taskInfo.description,
          timeStamp: timeStampMiliseconds,
          idTask: t.idTask,
          idUser: user.idUser,
          idAccount: user.idAccount,
        },
      };

      const loadingConfig = { dispatch, name: 'CANCEL_TASK' };
      cancelTaskRequest(body, props.onCloseModalSuccess, props.onCloseModalError, loadingConfig);
    }
  };
  return (
    <Dialog
      open
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
      scroll="body"
      slotProps={{
        paper: {
          className: 'Fielder-modals-header-border Fielder-modals-content-border',
          sx: {
            maxHeight: 'none',
            overflow: 'visible',
          },
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        className="Fielder-modals-create-edit-detail-header-border"
        sx={{ p: 1 }}
      >
        <Box display="flex" alignItems="center" justifyContent="flex-end">
          <IconButton id={'close-modal-button'} aria-label="close" onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {/* Body */}
      <DialogContent
        className="error-message-modal-body text-center"
        sx={{ overflow: 'visible', pt: 0 }}
      >
        <Stack alignItems="center" spacing={2}>
          <img src={DangerIcon} className="error-message-center-icon" alt="" />
          <div
            id="ErrorMessage-message"
            className="text-center ml-2 mr-2 error-message-margin"
          >
            {lan.messageConfirmaCancelTask}
          </div>
        </Stack>

        <Grid
          container
          spacing={1}
          alignItems="flex-start"
          sx={{ px: { xs: 2, sm: 6 }, mt: 2, width: '100%' }}
        >
          <Grid size={12}>
            <TextField
              id="description-red-input"
              placeholder={lan.cancelComment}
              value={taskInfo.description}
              onChange={(e) => setFieldValue(e.target.value, 'description')}
              multiline
              rows={5}
              fullWidth
              inputProps={{ maxLength: 255 }}
              error={descError}
              InputProps={{
                endAdornment: descError ? (
                  <InputAdornment position="end">
                    <img
                      src={redAlertIcon}
                      alt=""
                      className="myoperation-icon"
                      style={{ display: 'inline' }}
                    />
                  </InputAdornment>
                ) : null,
              }}
              sx={{
                mt: 1,
                '& .MuiOutlinedInput-root fieldset': descError
                  ? { borderColor: '#c70101' }
                  : undefined,
              }}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2} sx={{ px: { xs: 2, sm: 6 }, mt: 2, mb: 1 }}>
          <Grid size={12}>
            <div style={{ textAlign: 'justify', fontSize: 15, color: 'red' }}>
              {lan.cancelInformation}
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      {/* Footer */}
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button
          id="ErrorMessage-btn"
          type="submit"
          className="btn btn-outline-primary btn-success Fielder-modal-btnsave-size error-message-btn-margin"
          onClick={handleCancelTask}
        >
          {lan.cancel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default CancelTask;
//Original code:
/*import React, {useState } from 'react';
import DangerIcon from '@assets/icons/danger-alert-icon.svg';
import redAlertIcon from '@assets/icons/redAlert-icon.svg';
import { cancelTaskRequest } from '@core/api/task/task.service';
import { useSelector, useDispatch } from 'react-redux';
import { selectUser } from '@core/store/modules/session/sessionSelectors';
import { useLanguage } from 'FielderUtils/Contexts/LanguageContext';
const CancelTask = (props) => {
	const lan = useLanguage();
	const dispatch = useDispatch();
	const user = useSelector(selectUser);
	const [taskInfo, setTaskInfo] = useState({ description: '' });
	const [taskInfoRequest, setTaskInfoRequest] = useState(props.taskInfoRequest);
	const handleClose = () => props.closeErrorMessage();
	const setValidateDescription = () => {
		if (taskInfo.description !== '') {
			document.getElementById('description-alert-icon').style.display = 'none';
			document.getElementById('description-red-input').style.borderColor = '#ced4da';
		}
	};
	const setFieldValue = (value, field) => {
		if (field === 'description') {

			setTaskInfo(prevState => ({
				...prevState,
				description: value,
			}));

			setValidateDescription();
		}
	};
	const handleCancelTask = () => {
		if (taskInfo.description !== '') {
			const tasks = taskInfoRequest;
			const timeStamp = new Date();
			const timeStampMiliseconds = timeStamp.getTime();

			for (let i = 0; i < tasks.length; i++) {
				const body = {
					type: tasks[i].typeOfRequest,
					cancel: {
						comment: taskInfo.description,
						timeStamp: timeStampMiliseconds,
						idTask: tasks[i].idTask,
						idUser: user.idUser,
						idAccount: user.idAccount,
					},
				};

				const loadingConfig = {
					dispatch,
					name: 'CANCEL_TASK',
				};

				const onSuccess = props.onCloseModalSuccess
				const onError = props.onCloseModalError
				cancelTaskRequest(body, onSuccess, onError, loadingConfig);
			}
		} else {
			document.getElementById('description-alert-icon').style.display = 'inline';
			document.getElementById('description-red-input').style.borderColor = '#c70101';
		}
	};
	return (
    <React.Fragment>
      <Modal
        id='ErrorMessage-modal'
        size='md'
        show
        onHide={handleClose}
        className='Fielder-modals-header-border Fielder-modals-content-border'
      >
        <Modal.Header className='Fielder-modals-create-edit-detail-header-border' closeButton>
        </Modal.Header>
        <Modal.Body className='error-message-modal-body text-center'>
          <img src={DangerIcon} className='error-message-center-icon' alt='' />
          <div id='ErrorMessage-message' className='text-center ml-2 mr-2 mt-3 mb-3 error-message-margin'>
            {lan.messageConfirmaCancelTask}
          </div>
          <div className="row mx-3 mb-4">
          <div className="col" style={{ textAlign: 'justify', fontSize: '15px', color:'red' }}>
              {lan.cancelInformation}
            </div>
          </div>
          <div className='row-auto pl-5 pr-5'>
            <textarea
              className='form-control  text-left mt-1'
              maxLength='255'
              rows='5'
              cols='20'
              id='description-red-input'
              placeholder={lan.cancelComment}
              value={taskInfo.description}
              onChange={(e) => setFieldValue(e.target.value, 'description')}
            ></textarea>
            <img
              src={redAlertIcon}
              alt=''
              id='description-alert-icon'
              className='myoperation-icon'
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='col d-flex justify-content-center mt-3'>
            <button
              id='ErrorMessage-btn'
              type='submit'
              className='btn btn-outline-primary btn-success Fielder-modal-btnsave-size error-message-btn-margin'
              onClick={handleCancelTask}
            >
              {lan.cancel}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
export default CancelTask;
*/
